import axios from "axios";
import { verifyTruckIdSmiths } from "../functions/tools";
const url = process.env.REACT_APP_BASE_API_URL;
const url_filemgmt = process.env.REACT_APP_FILEMGMT_URL;

export const containerDownloadImg = async (trkid) => {
    let trkFile;
    if (verifyTruckIdSmiths(trkid)) {
        trkFile = trkid + "S.Img";
    } else {
        trkFile = trkid + "high.Img";
    }

    //const url2 = `${url_filemgmt}/v1/filemgmt/${trkid}/${trkFile}`;
    //console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(
        `${url_filemgmt}/v1/filemgmt/${trkid}/${trkFile}`,
        headers
    );
    return res.data;
};

export const postListarcontainerDownloadXls = async (operacao,
    veredito,
    dataInicial,
    dataFinal,
    conId,
    cliId
) => {
    if (typeof conId === "undefined") {
        conId = "None";
    } else if (conId === "") {
        conId = "None";
    }
    if (typeof cliId === "undefined") {
        cliId = 0;
    } else if (cliId === "") {
        cliId = 0;
    }

    const filter = {
        operacao: operacao,
        veridporto: veredito,
        dtinicial: dataInicial,
        dtfinal: dataFinal,
        conId: conId,
        cliId: cliId
    };

    const headers = {
        responseType: "arraybuffer",
    };

    const res = await axios.post(
        `${url}/v4/container/listarcontainersnopages`,
        filter,
        headers
    );
    return res.data;
};



export const containerDownloadJpeg = async (trkid) => {
    let trkFile;
    let url2;

    if (verifyTruckIdSmiths(trkid)) {
        trkFile = trkid + "S.jpg";
        url2 = `${url_filemgmt}/v1/filemgmt/${trkid}/${trkFile}`;

    } else {
        trkFile = trkid + "S.jpg";
        url2 = `${url_filemgmt}/v1/filemgmt/jpgfromtif/${trkid}`;

    }

    //const trkFile = trkid + "S.jpg";
    //const url2 = `${url_filemgmt}/v1/filemgmt/${trkid}/${trkFile}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};




export const containerLaudo = async (conId) => {
    const url2 = `${url}/v1/container/laudo/${conId}`;
    const headers = {
        responseType: "blob",
        "Content-Type": "application/pdf",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};


export const containerDownloadTiff = async (trkid) => {
    const trkFile = trkid + "S.tif";
    const url2 = `${url_filemgmt}/v1/filemgmt/${trkid}/${trkFile}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerDownloadJson = async (trkid) => {
    const jsonFile = "inspection.json";
    const url2 = `${url_filemgmt}/v1/filemgmt/${trkid}/${jsonFile}`;
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerDownloadXml = async (trkid) => {
    const trkFile = trkid + ".xml";
    const url2 = `${url_filemgmt}/v2/filemgmt/${trkid}/${trkFile}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerImagewithmarks = async (conContainer, trkid) => {
    const url = `${url_filemgmt}/v1/suspectb64/${conContainer}/${trkid}`;
    return await axios.get(url);
};

export const containerDownloadImgFromBackEnd = async (trkid) => {
    //const trkFile = trkid + "S.Img";
    const url2 = `${url}/v2/container/downloadimg/${trkid}`;
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerDownloadJpegFromBackEnd = async (trkid) => {
    //    const trkFile = trkid + "S.Img";
    const url2 = `${url}/v2/container/downloadjpeg/${trkid}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerDownloadTiffFromBackEnd = async (trkid) => {
    //    const trkFile = trkid + "S.Img";
    const url2 = `${url}/v2/container/downloadtiff/${trkid}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerDownloadXmlFromBackEnd = async (trkid) => {
    //    const trkFile = trkid + "S.Img";
    const url2 = `${url}/v2/container/downloadxml/${trkid}`;
    console.log("Veio para o container", url2);
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    const res = await axios.get(url2, headers);
    return res.data;
};

export const containerImagewithmarksFromBackEnd = async (trkid) => {
    //const headers = { 'responseType': 'blob', 'Content-Type': 'application/octet-stream' }
    //console.log('TrkId', trkid);
    return await axios.get(url + "/v2/container/imagewithmarks/" + trkid);
};

export const uploadSuspectImage = async (img) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.post(url + "/v1/container/uploadsuspectimage", img, {
        headers,
    });
};

export const findPendentes = async (id, dtInicial, dtFinal) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/pendente/" + id + "/" + dtInicial + "/" + dtFinal,
        { headers }
    );
};

export const findInconsistentes = async (id, dtInicial, dtFinal) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/inconsistente/" + id + "/" + dtInicial + "/" + dtFinal,
        { headers }
    );
};

export const findSuspeitos = async (id, dtInicial, dtFinal) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/suspeito/" + id + "/" + dtInicial + "/" + dtFinal,
        { headers }
    );
};

export const findAprovados = async (id, dtInicial, dtFinal) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/aprovado/" + id + "/" + dtInicial + "/" + dtFinal,
        { headers }
    );
};

export const availableOperador = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/availableoperador/" + container.usu_id,
        { headers }
    );
};

export const availableSupervisor = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/availablesupervisor/" + container.usu_id,
        { headers }
    );
};

export const containerUpdate = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(url + "/v1/container/update/", container, { headers });
};

export const containerImagehighresolution = async (trkid) => {
    const headers = {
        responseType: "blob",
        "Content-Type": "application/octet-stream",
    };
    return await axios.get(
        url + "/v1/container/imagehighresolution/" + trkid,
        headers
    );
};

export const containerDownloadImgFile = async (trkid) => {
    const headers = { responseType: "blob", "Content-Type": "image/jpeg" };
    return await axios.get(
        url + "/v1/container/imagelowresolution/" + trkid,
        headers
    );
};

export const containerLowresolution = async (trkid) => {
    const headers = { responseType: "blob", "Content-Type": "image/jpeg" };
    return await axios.get(
        url + "/v1/container/imagelowresolution/" + trkid,
        headers
    );
};

export const updateVereditoAprovado = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(
        url + "/v1/container/updatevereditoaprovado",
        container,
        { headers }
    );
};

export const updateVereditoInconsistente = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(
        url + "/v1/container/updatevereditoinconsistente",
        container,
        { headers }
    );
};

export const updateVereditoSuspeito = async (container) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.put(
        url + "/v1/container/updatevereditosuspeito",
        container,
        { headers }
    );
};

export const listarContainers = async (
    operacao,
    veredito,
    dataInicial,
    dataFinal,
    conId,
    cliId
) => {
    const headers = { "Content-Type": "application/json" };
    if (typeof conId === "undefined") {
        conId = "None";
    } else if (conId === "") {
        conId = "None";
    }
    if (typeof cliId === "undefined") {
        cliId = 0;
    } else if (cliId === "") {
        cliId = 0;
    }

    console.log(
        "URL",
        url +
        `/v3/container/listarcontainers/${operacao}/${veredito}/${dataInicial}/${dataFinal}/${conId}/${cliId}`
    );

    return await axios.get(
        url +
        `/v3/container/listarcontainers/${operacao}/${veredito}/${dataInicial}/${dataFinal}/${conId}/${cliId}`,
        { headers }
    );
};



export const postListarContainers = async (
    operacao,
    veredito,
    dataInicial,
    dataFinal,
    conId,
    cliId,
    pagina,
    linhasPorPagina
) => {
    const headers = { "Content-Type": "application/json" };
    if (typeof conId === "undefined") {
        conId = "None";
    } else if (conId === "") {
        conId = "None";
    }
    if (typeof cliId === "undefined") {
        cliId = 0;
    } else if (cliId === "") {
        cliId = 0;
    }

    const filter = {
        operacao: operacao,
        veridporto: veredito,
        dtinicial: dataInicial,
        dtfinal: dataFinal,
        conId: conId,
        cliId: cliId,
        pagina: pagina,
        linhasPorPagina: linhasPorPagina
    };

    return await axios.post(
        url +
        `/v5/container/listarcontainers`, filter, { headers }
    );
};


export const listarMissingDirectory = async (
    sitId,
    dti,
    dtf
) => {
    const headers = { "Content-Type": "application/json" };
    if (!sitId) {
        sitId = "None";
    }

    return await axios.get(
        url +
        `/v1/missingdirectory/${sitId}/${dti}/${dtf}`,
        { headers }
    );
};


export const downloadListarContainersUpload = async (
    operacao,
    dtinicial,
    dtfinal,
    conId,
    trkId,
    sitId,
    cliId,
    vepSituacaoEnvio,
    pendente
) => {
    if (!conId) {
        conId = "None";
    }
    if (!trkId) {
        trkId = "None";
    }
    if (!vepSituacaoEnvio) {
        vepSituacaoEnvio = "None";
    }

    if (!sitId) {
        sitId = "None";
    }

    if (!cliId) {
        cliId = 0;
    }

    const res = await axios.get(
        url + `/v3/container/listarsituacaoupload-download-xml/${operacao}/${dtinicial}/${dtfinal}/${conId}/${trkId}/${sitId}/${cliId}/${vepSituacaoEnvio}/${pendente === true ? "1" : "0"}`,
        {
            responseType: "blob",
            headers: { "Content-Type": "application/octet-stream" },
        }
    );

    const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "situacao_download.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
};

export const listarContainersUpload = async (
    operacao,
    dtinicial,
    dtfinal,
    conId,
    trkId,
    sitId,
    cliId,
    vepSituacaoEnvio,
    pendente
) => {
    const headers = { "Content-Type": "application/json" };
    if (!conId) {
        conId = "None";
    }
    if (!trkId) {
        trkId = "None";
    }
    if (!vepSituacaoEnvio) {
        vepSituacaoEnvio = "None";
    }

    if (!sitId) {
        sitId = "None";
    }

    if (!cliId) {
        cliId = 0;
    }

    console.log(
        "URL",
        url +
        `/v3/container/listarsituacaoupload/${operacao}/${dtinicial}/${dtfinal}/${conId}/${trkId}/${sitId}/${cliId}/${vepSituacaoEnvio}/${pendente === true ? "1" : "0"}`
    );

    return await axios.get(
        url +
        `/v3/container/listarsituacaoupload/${operacao}/${dtinicial}/${dtfinal}/${conId}/${trkId}/${sitId}/${cliId}/${vepSituacaoEnvio}/${pendente === true ? "1" : "0"}`,
        { headers }
    );
};

export const listarByConContainer = async (conContainer) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/listarcontainersbyconcontainer/" + conContainer,
        { headers }
    );
};

export const listarByUsuId = async (usuId, operacao) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/listarcontainersbyusuid/" + usuId + "/" + operacao,
        { headers }
    );
};

export const listarByUsuIdPercentual = async (usuId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/listarcontainersbyusuidpercentual/" + usuId,
        { headers }
    );
};

export const vereditosAtribuidos = async (conId) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(
        url + "/v1/container/findvereditosatribuidos/" + conId,
        { headers }
    );
};

export const checkifexpired = async (value) => {
    const headers = { "Content-Type": "application/json" };
    const ret = await axios.post(url + "/v1/container/checkifexpired", value, {
        headers,
    });
    return ret;
};

export const msgconsole = async (value) => {
    const headers = { "Content-Type": "application/json" };
    return await axios.post(url + "/v1/container/msgconsole", value, { headers });
};

export const sysdatetime = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/container/sysdatetime", { headers });
};

export const sysdate = async () => {
    const headers = { "Content-Type": "application/json" };
    return await axios.get(url + "/v1/container/sysdate", { headers });
};
